import { useState } from 'react';
import { InputChangeEvent } from '../types';

export const useForm = <Inputs, Attachments, Refs>(
  defaults: Inputs,
  afterSubmit: (inputs: Inputs, attachments?: Attachments) => void,
  initialRefs?: Refs
) => {
  const [inputs, setInputs] = useState(defaults);
  const [refs, setRefs] = useState(initialRefs);

  const handleSubmit = (event: { preventDefault: () => void }) => {
    if (event) {
      event.preventDefault();
    }

    afterSubmit(inputs);
  };

  const handleInputChange = (event: InputChangeEvent) => {
    event.persist();
    setInputs((inputs: any) => ({
      ...inputs,
      [event.target.name]: event.target.value,
    }));

    setRefs((refs: any) => ({
      ...refs,
      [event.target.name]: event.target,
    }));
  };

  const resetInput = (inputName: string) => {
    setInputs((inputs: any) => ({
      ...inputs,
      [inputName]: '',
    }));

    setRefs((refs: any) => ({
      ...refs,
      [inputName]: null,
    }));
  };

  const resetInputs = () => {
    setInputs((inputs: any) => ({
      ...inputs,
      body: '',
      attachments: '',
    }));

    setRefs((refs: any) => ({
      ...refs,
      body: null,
      attachments: null,
    }));
  };

  return {
    resetInputs,
    handleSubmit,
    handleInputChange,
    inputs,
    setRefs,
    refs,
    resetInput,
  };
};

export default useForm;
